import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CameraPlus = function CameraPlus(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M22 11.5v3.1c0 2.2402 0 3.3603-.436 4.216a4 4 0 0 1-1.748 1.748C18.9603 21 17.8402 21 15.6 21H8.4c-2.2402 0-3.3603 0-4.216-.436a4 4 0 0 1-1.748-1.748C2 17.9603 2 16.8402 2 14.6V9.4c0-2.2402 0-3.3603.436-4.216a4 4 0 0 1 1.748-1.748C5.0397 3 6.1598 3 8.4 3h4.1M19 8V2m-3 3h6m-6 7c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4"
    })
  }));
};
export default CameraPlus;